// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { isNonEmptyString } from '@utils/type-checkers'
import { createResponseObj, generateHeaders } from '..'
import { stripeBaseUrl, } from '.'


type GetPaymentMethodResponse = (SuccessResponse & {
    paymentMethod: CreditCard | ApplePay | GooglePay
}) | FailedResponse

export class GetPaymentMethodRequest extends Request {
    private constructor(paymentId: string, init?: RequestInit) { super(`${stripeBaseUrl}/payment/${paymentId}/`, init) }
    static async init(paymentId: string | undefined, init?: RequestInit) {
        if (!isNonEmptyString(paymentId)) throw createResponseObj<FailedResponse>({ status: 'failed', type: 'local', name: 'invalid-payment-id ', message: 'Invalid Payment Id' })
        // The generateHeaders method sets the Content-Type header to `application/json` by default.
        // That header isn't supported with GET requests and has to be removed.
        const headers = await generateHeaders("Clerk-Token", init?.headers)
        headers.delete('Content-Type')
        return new GetPaymentMethodRequest(paymentId, {
            ...init,
            method: 'GET',
            headers: headers,
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<CreditCard | ApplePay | GooglePay> {
        const response = await fetch(this)
        const data = createResponseObj<GetPaymentMethodResponse>(await response.json())
        console.info("Get Payment Method Results:", data)
    
        switch (data.status) {
            case 'successful': return data.paymentMethod
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}